import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=68d67528&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=68d67528&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d67528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d67528')) {
      api.createRecord('68d67528', component.options)
    } else {
      api.reload('68d67528', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=68d67528&scoped=true", function () {
      api.rerender('68d67528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Sidebar.vue"
export default component.exports